import Tippy, { useSingleton } from "@tippyjs/react";
import cn from "classnames";
import { memo } from "react";
import { Tooltip } from "@/interface/ui/Tooltip";
import { capitalize, EMOJI_GROUPS } from "../../lib";
import styles from "./EmojiPanelGroups.module.scss";

type Props = {
    size: "s" | "m";
    activeGroup: string | null;
    onClick: (groupLabel: string) => void;
};

export const EmojiPanelGroups = memo(function EmojiPanelGroups({
    size,
    activeGroup,
    onClick,
}: Props) {
    const [source, target] = useSingleton();

    const handleClick = (groupLabel: string) => () => onClick(groupLabel);

    const getButtonClassname = (group: { label: string }) => {
        return cn(styles.groupButton, [styles[`groupButtonSize${capitalize(size)}`]], {
            [styles.selected]: activeGroup === group.label,
        });
    };

    return (
        <div
            className={cn(styles.groupButtonList, styles[`groupButtonListSize${capitalize(size)}`])}
            data-testid="EmojiPanel.GroupButtons"
        >
            <Tippy singleton={source} />
            {EMOJI_GROUPS.map((group) => (
                <Tooltip key={group.label} singleton={target} content={group.label} placement="top">
                    <button
                        type="button"
                        className={getButtonClassname(group)}
                        data-testid="EmojiPanel.GroupButtons.Group"
                        onClick={handleClick(group.label)}
                    >
                        {size === "m" ? group.iconM : group.iconS}
                    </button>
                </Tooltip>
            ))}
        </div>
    );
});
